import React from 'react';
import Highcharts from 'highcharts';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';
import { Box, CircularProgress, Paper } from '@material-ui/core';
import PeriodicityButton from './utils/PeriodicityButton';
import ExportCsvButton from './utils/ExportCsvButton';
import { exportToCsv, exportToExcel } from './utils/csvExport';
import {
  getMultipleExchangesQuantity,
  getReasonsQuantities,
  getExchangesFollowedByRefundsQuantity
} from '../dashboardActions';

const ReturnReasonChart = ({
  reasonsQuantities,
  exchangesFollowedByRefundsQuantity,
  multipleExchangesQuantity,
  dispatchGetReasonsQuantities,
  dispatchGetMultipleExchangesQuantity,
  dispatchGetExchangesFollowedByRefundsQuantity,
  loadingReasonsQuantities
}) => {
  const optionsBase = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie'
    },
    credits: {
      enabled: false
    },
    title: {
      text: ''
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    plotOptions: {
      pie: {
        innerSize: 148,
        size: 197,
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        },
        showInLegend: true
      }
    }
  };

  const options1 = {
    ...optionsBase,
    series: [
      {
        name: 'Brands',
        colorByPoint: true,
        data: reasonsQuantities
          .filter(r => r.returnNatureCode === 'return')
          .map(reason => ({
            name: reason.returnReason,
            y: reason.quantity
          }))
      }
    ]
  };

  const options2 = {
    ...optionsBase,
    series: [
      {
        name: 'Brands',
        colorByPoint: true,
        data: reasonsQuantities
          .filter(r => r.returnNatureCode === 'exchange')
          .map(reason => ({
            name: reason.returnReason,
            y: reason.quantity
          }))
      }
    ]
  };
  return (
    <Paper
      style={{
        paddingTop: 48,
        paddingBottom: 24,
        borderRadius: 20,
        width: '100%'
      }}
    >
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center" mb={4} pl={10}>
          <Box fontSize={28} color="#001C56">
            Raisons des retours
          </Box>
          <ExportCsvButton
            onClick={() => {
              const columns = ['Raison', 'Nature (échange/retour)', 'Quantité'];
              const rows = reasonsQuantities.map(r => [
                r.returnReason,
                r.returnNatureCode === 'exchange' ? 'Échange' : 'Remboursement',
                r.quantity
              ]);
              exportToCsv('raisons_des_retours', columns, rows);
            }}
            onExcelClick={() => {
              const columns = ['Raison', 'Nature (échange/retour)', 'Quantité'];
              const rows = reasonsQuantities.map(r => [
                r.returnReason,
                r.returnNatureCode === 'exchange' ? 'Échange' : 'Remboursement',
                r.quantity
              ]);
              exportToExcel('raisons_des_retours', columns, rows);
            }}
          />
        </Box>
        <Box pr={8}>
          <PeriodicityButton
            onChange={({ dateFrom, dateTo }) => {
              const params = { dateFrom, dateTo, period: 'month' };
              dispatchGetReasonsQuantities(params);
              dispatchGetMultipleExchangesQuantity(params);
              dispatchGetExchangesFollowedByRefundsQuantity(params);
            }}
          />
        </Box>
      </Box>
      <div style={{ display: 'flex' }}>
        <div style={{ width: '50%' }}>
          <Box fontSize={23} color="#001C56" pl={10}>
            Échange
          </Box>
          {loadingReasonsQuantities ? (
            <Box display="flex" justifyContent="center" p={20}>
              <CircularProgress size={60} />
            </Box>
          ) : (
            <HighchartsReact highcharts={Highcharts} options={options1} />
          )}

          <Box textAlign="center" mt={2}>
            <span style={{ fontSize: 36 }}>{multipleExchangesQuantity}</span>
            <span style={{ marginLeft: 16, fontSize: 14 }}>échange &gt; 2</span>
          </Box>
        </div>
        <div style={{ width: '50%' }}>
          <Box fontSize={23} color="#001C56" pl={10}>
            Remboursement
          </Box>

          {loadingReasonsQuantities ? (
            <Box display="flex" justifyContent="center" p={20}>
              <CircularProgress size={60} />
            </Box>
          ) : (
            <HighchartsReact highcharts={Highcharts} options={options2} />
          )}

          <Box textAlign="center" mt={2}>
            <span style={{ fontSize: 36 }}>
              {exchangesFollowedByRefundsQuantity}
            </span>
            <span style={{ marginLeft: 16, fontSize: 14 }}>
              Échange =&gt; Remboursement
            </span>
          </Box>
        </div>
      </div>
    </Paper>
  );
};

const mapStateToProps = state => ({
  reasonsQuantities: state.dashboard.reasonsQuantities,
  loadingReasonsQuantities: state.dashboard.loadingReasonsQuantities,
  multipleExchangesQuantity: state.dashboard.multipleExchangesQuantity,
  exchangesFollowedByRefundsQuantity:
    state.dashboard.exchangesFollowedByRefundsQuantity
});

const mapDispatchToProps = dispatch => ({
  dispatchGetReasonsQuantities: params =>
    dispatch(getReasonsQuantities(params)),
  dispatchGetMultipleExchangesQuantity: params =>
    dispatch(getMultipleExchangesQuantity(params)),
  dispatchGetExchangesFollowedByRefundsQuantity: params =>
    dispatch(getExchangesFollowedByRefundsQuantity(params))
});

ReturnReasonChart.propTypes = {
  reasonsQuantities: PropTypes.array,
  exchangesFollowedByRefundsQuantity: PropTypes.number,
  multipleExchangesQuantity: PropTypes.number,
  dispatchGetReasonsQuantities: PropTypes.func,
  dispatchGetMultipleExchangesQuantity: PropTypes.func,
  dispatchGetExchangesFollowedByRefundsQuantity: PropTypes.func,
  loadingReasonsQuantities: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(ReturnReasonChart);
